import { findValidFieldId } from "./findValidFieldId";

const key = "add-no-engine";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = (validFieldId) => ({
	"Id": 5,
	"Title": "No Engine",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Conditions":
	[
		{
			"Id": 1,
			"Field":
			{
				"Id": validFieldId
			}
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithNoEngine = ruleJson(findValidFieldId(resp.data.Data));
	resp.data.Data.Rules.push(ruleWithNoEngine);
};

export const addNoEngine = [key, applicable, modify];